<cf-frontend-sdk-cplace-control-skeleton
  [componentId]="componentId"
  [label]="label"
  [labelPosition]="labelPosition"
  [labelFor]="nativeFormComponentId"
  [validationMessage]="validationMessage"
  [validationSeverity]="validationSeverity"
  [alert]="alert"
  [required]="required"
  [editMode]="($editMode | async)!"
  [submitting]="submitting"
  [submitSuccess]="($submitSuccess | async)!"
  [submitDisabled]="($submitDisabled | async)!"
  [readonly]="readonly"
  [disabled]="disabled"
  (cancelButtonClick)="onCancel()"
>
  <div class="cf-frontend-sdk-cplace-multi-select-control-wrapper" [class.cf-frontend-sdk-empty-value]="($showEmptyValue | async)!">
    <p-multiSelect
      [options]="options"
      optionLabel="label"
      scrollHeight="294"
      [showHeader]="showHeader()"
      [resetFilterOnHide]="true"
      [dropdownIcon]="getDropdownIcon()"
      [filterPlaceHolder]="'cf-frontend-sdk.shared.search' | translate"
      [inputId]="nativeFormComponentId"
      [label]="label"
      [required]="required"
      [disabled]="disabled"
      [readonly]="readonly"
      [ariaFilterLabel]="'cf-frontend-sdk.shared.search' | translate"
      [emptyMessage]="'cf-frontend-sdk.shared.noResults' | translate"
      [emptyFilterMessage]="'cf-frontend-sdk.shared.noResults' | translate"
      [(ngModel)]="value"
      optionValue="value"
      (onClick)="handleOnClick($event)"
    >
      <ng-template let-option pTemplate="item">
        <div class="cf-frontend-sdk-cplace-multi-select-control-option-item">
          <i *ngIf="option.icon" [class]="option.icon"></i>
          <span>{{ option.label }}</span>
        </div>
      </ng-template>
    </p-multiSelect>
  </div>
</cf-frontend-sdk-cplace-control-skeleton>
